import { render, staticRenderFns } from "./FifthPlan.vue?vue&type=template&id=6936a27b&scoped=true&"
import script from "./FifthPlan.vue?vue&type=script&lang=js&"
export * from "./FifthPlan.vue?vue&type=script&lang=js&"
import style0 from "./FifthPlan.vue?vue&type=style&index=0&id=6936a27b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6936a27b",
  null
  
)

export default component.exports